import { render } from "./FaceEditModal.vue?vue&type=template&id=3108e485&scoped=true&ts=true"
import script from "./FaceEditModal.vue?vue&type=script&lang=ts"
export * from "./FaceEditModal.vue?vue&type=script&lang=ts"

import "./FaceEditModal.vue?vue&type=style&index=0&id=3108e485&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3108e485"]])

export default __exports__